import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useIdleTimeout from "hooks/useIdleTimeout";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import { getEnv } from "helpers/environment";

function IdleTimeoutDialog() {
  const { t } = useTranslation("flowDesigner");
  const [showDialog, setShowDialog] = useState(false);
  const [timeUntilLogout, setTimeUntilLogout] = useState("2:00 minute");
  let maxSeconds = 120;
  let countdownInterval = null;

  const handleIdle = () => {
    setShowDialog(true);
    window.focus();
  };

  const onMessage = () => {
    setShowDialog(false);
    idleTimer.reset();
    setTimeUntilLogout("2:00 minute");
  };

  const { idleTimer } = useIdleTimeout({
    onMessage,
    onIdle: handleIdle,
    idleTime: getEnv("IDLE_SESSION_TIMEOUT")
  });

  const stay = () => {
    idleTimer.message("stay", true);
    // stopCountDown();
  };

  const onClose = () => {};

  const startCountDown = () => {
    countdownInterval = setInterval(() => {
      let time = --maxSeconds;

      if (time < 0) {
        time = 0;
      }

      let minutes = Math.floor(time / 60);
      let seconds = time - minutes * 60;
      setTimeUntilLogout(`${minutes}:${seconds < 10 ? "0" + seconds : seconds} minute`);
    }, 1000);
  };

  useEffect(() => {
    if (showDialog) {
      startCountDown();
    }
    return () => clearInterval(countdownInterval);
  }, [showDialog]);

  return (
    <Dialog
      open={showDialog}
      onClose={onClose}
      aria-labelledby="idleDialogTitle"
      aria-describedby="idleDialogDescription"
    >
      <DialogTitle id="idleDialogTitle">
        {t("dialogs.idle_timeout.title", { time: timeUntilLogout })}
      </DialogTitle>
      <DialogContent id="idleDialogDescription">
        <SoftBox sx={{ marginBottom: "20px" }}>{t("dialogs.idle_timeout.content_1")}</SoftBox>
        <SoftBox>{t("dialogs.idle_timeout.content_2")}</SoftBox>
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={stay} color="primary">
          {t("buttons.ok")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}

export default IdleTimeoutDialog;
